<template>
  <div id="starnote">
      <b-input
        class="mb-2 mr-sm-2 mb-sm-0 search"
        placeholder="搜索" v-model="keywords"
      ></b-input>

     <div class="article">
        <div class="content" v-for="post in search(keywords)">
            <router-link :to="'/@'+post.author+'/'+post.permlink">
                <img src="../../static/images/star.svg"  alt="StarNote">
                {{ post.title }} 　
            </router-link>

            <p class="posttime">@{{ post.author }} 　{{ post.created | formatTime}} </p>
            <p>摘要：{{ JSON.parse(post.json_metadata).text }}</p>
         </div>

     </div>

    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

      <div class="btn" v-if="showMoreFlag">
          <b-button variant="outline-primary" @click="getNext">查看更多</b-button>
      </div>

  </div>
</template>

<script>
  import Loading from './Loading'
  import Replylist from './Replylist'
    export default {
      name: "Index",
      data() {
        return {
            keywords: '',
            isLoading: false,
            posts:[],
            author:'',
            permlink:'',
            showMoreFlag: true
          }
      },
      methods: {
          getCreated(){
              this.isLoading = true
              let query = { tag: "starnote", limit : 20 }
              this.steem.api.getDiscussionsByCreated(query, (err, data) => {
                  //取到最后一篇文章的author和Permlink，做为下一次查询的起始点
                  this.author = data[data.length - 1].author
                  this.permlink = data[data.length - 1].permlink
                  //对文章过滤
                  let res = this.filterPosts(data)
                  //将得到的数据存入vuex中
                  this.posts = res
                  this.$store.commit('saveCreated', res)
                  this.isLoading = false
              })
          },
          getNext(){
              this.isLoading = true
              let query = {tag: "starnote", limit: 20, start_author: this.author, start_permlink: this.permlink}
              this.steem.api.getDiscussionsByCreated(query, (err, data) => {
                  data.forEach(post => {
                      let json = JSON.parse(post.json_metadata)
                      if (post.category === "starnote" && json.dapp === "starnote"  && post.permlink !== this.permlink) {
                          this.posts.push(post)
                      }
                  })
                  //取到最后一篇文章的author和Permlink，做为下一次查询的起始点
                  this.author = data[data.length - 1].author
                  this.permlink = data[data.length - 1].permlink
                  //将得到的数据存入vuex中
                  this.$store.commit('saveCreated', this.posts)
                  this.isLoading = false
                  if(data.length === 1){
                      this.showMoreFlag = false
                      alert('没有更多笔记了！')
                  }
              })
          },
          filterPosts(posts) {
              let res = []
              posts.forEach(item => {
                  let json = JSON.parse(item.json_metadata)
                  if (item.category === "starnote" && json.dapp === "starnote") {
                      res.push(item)
                  }
              })
              return res
          },
          search(keywords){
              let posts = this.$store.state.created
              return posts.filter(item => {
                  if(item.title.includes(keywords)){
                      // console.log(166, '查到了！')
                      return item
                  }
              })
          },
      },

      filters:{
        formatTime(data){
          return data.substring(0,10)
        }
      },

      components: {
        Loading,
        Replylist
      },

        mounted() {
            //如果vuex中有值，则直接取出，否则从steem网络中取
            if(this.$store.state.created != false){
                console.log(111, "从vuex中取值")
                this.isLoading = false

                //把初始化的数值补回
                let data = this.$store.state.created
                this.posts = data
                this.author = data[data.length - 1].author
                this.permlink = data[data.length - 1].permlink
            }else{
                console.log(112, "从steem中取值")
                this.getCreated()
            }
        }
    }

</script>

<style scoped>
    #starnote{
        width: 80%;
        margin: 0 auto;
    }

  .article{
    margin-top: 1rem;
  }
  .posttime{
    font-size: 0.8rem;
    display: inline;
      margin-left: 0.5rem;
  }
  .content{
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 70%;
    border-bottom: 1px solid #ddd;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;
  }

  .search{
    margin: 1rem auto !important;
    width: 75%;
  }

    .btn{
        display: block;
        margin: 0.5rem auto;
    }


</style>
